import { MeshReflectorMaterial } from '@react-three/drei';
import { INTERNAL_CONFIG } from '../config/internalConfig';

export const ReflectivePlane = () => {
// todo: set size according to model
  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,-0.01,0]}>
      <planeGeometry args={[INTERNAL_CONFIG.floorSize, INTERNAL_CONFIG.floorSize]} />
      <MeshReflectorMaterial
        // blur={[300, 300]}
        resolution={2048}
        // mixBlur={0.5}
        mixStrength={190}
        roughness={1}
        depthScale={0.5}
        minDepthThreshold={0.8}
        // maxDepthThreshold={2}
        // color="#ffffff"
        metalness={0}
      />
    </mesh>
  );
};
